import { useMemo, Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";

import { isEqual, subMonths, format } from "date-fns";

import { DateRangePicker } from "react-date-range";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

export default function DayRange({ dayRange: { startDate, endDate }, onUpdate }: any) {
  const currDate = useMemo(() => new Date(), []);

  // useEffect(() => {
  //   onUpdate({ startDate: startOfISOWeek(currDate), endDate });
  // }, [currDate, endDate, onUpdate]);

  return (
    <Menu
      as="div"
      className="relative text-gray-500"
    >
      <div>
        <Menu.Button
          className="max-w-xs rounded flex items-center px-4 py-2 text-sm bg-white border border-gray-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-white"
          id="user-menu-button"
          aria-expanded="false"
          aria-haspopup="true"
        >
          <span className="sr-only">Open day range menu</span>
          {format(startDate, "dd MMM yyyy")}
          {" - "}
          {format(endDate, "dd MMM yyyy")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="6"
            className="ml-3"
            viewBox="0 0 10 6"
          >
            <path
              id="arrow"
              d="M1.292.16A.568.568,0,0,0,.5.16L.167.487a.54.54,0,0,0,0,.774L3.984,5,.163,8.739a.54.54,0,0,0,0,.774L.5,9.84a.568.568,0,0,0,.79,0L5.837,5.386a.544.544,0,0,0,0-.776Z"
              transform="translate(10) rotate(90)"
              fill="#5273E8"
            />
          </svg>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className="origin-top-right absolute z-10 right-4 mt-2 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none cursor-pointer"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="user-menu-button"
        >
          <Menu.Item>
            <DateRangePicker
              className=""
              dateDisplayFormat="d MMM, yyyy"
              scroll={{ enabled: true }}
              ranges={[
                {
                  startDate,
                  endDate,
                  key: "selection",
                },
              ]}
              inputRanges={[]}
              minDate={subMonths(currDate, 2)}
              maxDate={currDate}
              onChange={(range: any) => {
                const { startDate, endDate } = range.selection;
                if (isEqual(startDate, endDate)) {
                  endDate.setHours(23);
                }
                onUpdate({ startDate, endDate });
              }}
            />
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
